import type { PropsWithChildren, ReactNode } from 'react'

import { Tooltip } from '../Tooltip'

type Props = {
  info?: ReactNode
  meta?: string
  disabled?: boolean
  hoverableInfo?: boolean
}

/*
 * Used for providing some additional information as an info bubble
 */
export default function InfoGroup({
  info,
  meta,
  disabled,
  hoverableInfo,
  children,
}: Readonly<PropsWithChildren<Props>>): ReactNode {
  if (!info) return children

  return (
    <div>
      {children}
      <Tooltip content={info} disabled={disabled} hoverableContent={hoverableInfo} />
      <span className="ep-form-row-label-text ep-form-row-label-counter">{meta}</span>
    </div>
  )
}
